import type { ReactNode } from "react";
import Card from "../UI/Card";
import Text from "../UI/Text";
import Title from "../UI/Title";
import styles from "./AutomatisationCard.module.css";

interface AutomatisationCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export default function AutomatisationCard({
  title = "Automatisations",
  subtitle = "Gagnez du temps sur la gestion locative. Activez uniquement ce qui vous convient.",
  children,
}: AutomatisationCardProps) {
  return (
    <Card>
      <div className={styles.header}>
        <Title variant="deca" weight="bold">
          {title}
        </Title>
        <Text color="muted">{subtitle}</Text>
      </div>
      <div className={styles.grid}>{children}</div>
    </Card>
  );
}
